import AiDocument from './AiDocument'

export default AiDocument
